// import { OrgMsgCn } from '../../super/orgModoule/info'
export const schoolInfo = {
  modalTitle: '报名信息',
  name: '机构名称',
  principal: '负责人姓名',
  department: '所属部门',
  position: '职务',
  mobile: '手机号码',
  telephone: '座机号码'
}
export const caseInfo = {
  create_id: '作品编号',
  title: '作品名称',
  path: '作品附件',
  author: '作者姓名',
  mobile: '作者手机号',
  profile: '作品简介',
  operation: '操作',
  recommend: '推荐',
  cancelRecommend: '取消推荐',
  search: '查询'
}
